import { useEffect, useState } from "react";
import {
  Button,
  Box,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { UseAdvCustomer } from "./UseAdvCustomer";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import AdvertismentsAutoComplete from "../advertisments/AdvertismentsAutoComplete";
import { removeComma, toMoney } from "../../util/Utils";

export default function AddAdvCustomer(props) {
  const { toSolar } = require("jdate-convert");

  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  const [advCustomer, setAdvCustomer] = useState();
  const { validate, addAdvCustomer } = UseAdvCustomer();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const Grades = [1, 2, 3];
  const { isSmall } = useBreakpoints();
  const [valueStart, setValueStart] = useState();
  const [valueEnd, setValueEnd] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];

  const [state, setState] = useState({
    companyName: undefined,
    contactPoint: undefined,
    contactPointMobile: undefined,
    economicCode: undefined,
    nationalCode: undefined,
    postalCode: undefined,
    registerNO: undefined,
    address: undefined,
    phone: undefined,
    isOfficial: false,
  });

  const [errorState, setErrorState] = useState({
    companyName: false,
    contactPointMobile: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "تبلیغات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/advertismentcustomers" },
          {
            name: "افزودن مشتری",
            url: "/advertismentcustomers/addAdvCustomer",
          },
        ],
      }}
    >
      {!advCustomer ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.companyName ? state.companyName : ""}
              error={errorState.companyName}
              label="نام شرکت"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  companyName: evt.target.value,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.contactPoint ? state.contactPoint : ""}
              label="نام مشتری"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  contactPoint: evt.target.value,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.contactPointMobile ? state.contactPointMobile : ""}
              label="موبایل"
              size="small"
              error={errorState.contactPointMobile}
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  contactPointMobile: evt.target.value,
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 7"}>
            <FormControlLabel
              checked={state.isOfficial ? state.isOfficial : false}
              onChange={(evt) => {
                setState({ ...state, isOfficial: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="فاکتور به صورت رسمی ارسال شود"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              disabled={!state.isOfficial}
              fullWidth
              value={state.address ? state.address : ""}
              label="آدرس"
              multiline
              rows={3}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, address: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}

          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              disabled={!state.isOfficial}
              fullWidth
              value={state.phone ? state.phone : ""}
              label="تلفن"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  phone: evt.target.value,
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              disabled={!state.isOfficial}
              fullWidth
              value={state.economicCode ? state.economicCode : ""}
              label="کد اقتصادی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  economicCode: evt.target.value,
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              disabled={!state.isOfficial}
              fullWidth
              value={state.nationalCode ? state.nationalCode : ""}
              label="شناسه ملی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  nationalCode: evt.target.value,
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              disabled={!state.isOfficial}
              fullWidth
              value={state.postalCode ? state.postalCode : ""}
              label="کد پستی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  postalCode: evt.target.value,
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              disabled={!state.isOfficial}
              fullWidth
              value={state.registerNO ? state.registerNO : ""}
              label="شماره ثبت"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  registerNO: evt.target.value,
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  setMsGotoLast(true);
                  addAdvCustomer(state, () => {
                    navigate("/advertismentcustomers", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/advertismentcustomers", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
